export default function ShareIcon() {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2456 0.405285L21.3543 6.99751C21.7317 7.30435 21.7307 7.8809 21.3521 8.18641L13.2434 14.7308C12.7431 15.1346 11.998 14.7785 11.998 14.1355V10.95C8.6881 11.0141 6.57049 11.6347 5.10511 12.6342C3.5515 13.6938 2.63461 15.2443 1.84484 17.2939C1.67828 17.7262 1.24238 17.8381 0.937782 17.7601C0.632292 17.6818 0.302056 17.3718 0.367826 16.9102C0.911677 13.0932 1.79966 10.0735 3.6869 7.92914C5.50183 5.86695 8.15153 4.71019 11.998 4.30352L11.998 0.998869M13.328 2.18636L13.328 5.52103L12.7179 5.57157C8.7275 5.90214 6.28219 6.99339 4.6853 8.80783C3.6605 9.97226 2.94544 11.4772 2.42271 13.3789C2.95485 12.6817 3.58485 12.0612 4.35569 11.5354C6.22945 10.2574 8.8386 9.60436 12.6648 9.61464L13.328 9.61642V12.9534L19.974 7.5895L13.328 2.18636Z"
        fill="#830051"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2456 0.405285C12.7457 -0.00113289 11.998 0.354611 11.998 0.998869L11.998 4.30352C8.15153 4.71019 5.50183 5.86695 3.6869 7.92914C1.79966 10.0735 0.911677 13.0932 0.367826 16.9102C0.302056 17.3718 0.632292 17.6818 0.937782 17.7601C1.24238 17.8381 1.67828 17.7262 1.84484 17.2939C2.63461 15.2443 3.5515 13.6938 5.10511 12.6342C6.57049 11.6347 8.6881 11.0141 11.998 10.95V14.1355C11.998 14.7785 12.7431 15.1346 13.2434 14.7308L21.3521 8.18641C21.7307 7.8809 21.7317 7.30435 21.3543 6.99751L13.2456 0.405285ZM13.328 5.52103L12.7179 5.57157C8.7275 5.90214 6.28219 6.99339 4.6853 8.80783C3.6605 9.97226 2.94544 11.4772 2.42271 13.3789C2.95485 12.6817 3.58485 12.0612 4.35569 11.5354C6.22945 10.2574 8.8386 9.60436 12.6648 9.61464L13.328 9.61642V12.9534L19.974 7.5895L13.328 2.18636L13.328 5.52103Z"
        fill="#830051"
      />
    </svg>
  )
}
